export default __webpack_public_path__ + "static/media/digital.3f6c3dc9.png";